<template>
  <div id="editor_container" style="display: none;" class="modal-mask">
    <div>
      <div class="modal-container">
        <div class="modal-header">
          <slot name="header" class="text-center">
            Edit cell content
          </slot>
        </div>
        <div class="modal-body" id="trumbowyg_wrapper" :class="{ 'disable-toolbar': noHtml }">
          <quill-editor
            v-model="localValue"
            :options="editorOptions"
            ref="quill"
          />
        </div>
        <div class="modal-footer">
          <slot name="footer">
            <button class="btn btn-large btn-default btn-danger" @click="closeEditorModal">
              Cancel
            </button>
            <button class="btn btn-large btn-default btn-primary" @click="submitEdit">
              Submit
            </button>
          </slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrumbowygContainer',
  props: {
    inputData: null,
    noHtml: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      localValue: '',
      originalValue: '',
      openedBlank: true,
      modalActive: false,
      editorOptions: {
  theme: 'snow',
  modules: {
    toolbar: {
      // keep your original toolbar array
      container: [
        [{ header: [1, 2, 3, false] }],
        ['bold', 'italic', 'underline', 'strike'],
        [{ color: [] }, { background: [] }],
        [{ list: 'ordered' }, { list: 'bullet' }],
        [{ align: [] }],
        ['link', 'image'],
        ['clean']
      ],
      handlers: {
        image: function () {
          const input = prompt('Enter image URL and optional description separated by "|" (e.g. https://example.com/image.png|This is the caption)')
          if (!input) return

          const [url, desc] = input.split('|')
          const range = this.quill.getSelection(true) || { index: this.quill.getLength() }

          // insert the image
          this.quill.insertEmbed(range.index, 'image', url.trim())
          
          // insert description as a new line if provided
          if (desc && desc.trim()) {
            this.quill.insertText(range.index + 1, '\n' + desc.trim() + '\n', { italic: true, color: '#555' })
          }

          // move cursor below the inserted content
          this.quill.setSelection(range.index + (desc ? 2 + desc.length : 1))
        }
      }
    }
  }
      }
    };
  },
  watch: {
    inputData: {
      immediate: true,
      handler(val) {
        const normalized = val || ''
        this.originalValue = normalized
        this.openedBlank = normalized.length === 0
        this.localValue = normalized
        if (this.modalActive) {
          this.focusEditor()
        }
      }
    }
  },
  methods: {
    submitEdit() {
      if (this.noHtml) {
        const quill = this.$refs.quill && this.$refs.quill.quill;
        // quill.getText() always ends with a trailing "\n"; remove it but keep any other intentional newlines
        const text = quill ? quill.getText().replace(/\n$/, '') : '';
        this.$emit('update', text);
      } else {
        this.$emit('update', this.localValue || '');
      }
      this.closeEditorModal(false);
    },
    closeEditorModal(restoreOriginal = true) {
      const elem = document.querySelector('#editor_container');
      if (elem) {
        elem.style.display = 'none';
      }
      if (restoreOriginal) {
        this.localValue = this.openedBlank ? '' : this.originalValue;
      }
      const quill = this.$refs.quill && this.$refs.quill.quill;
      if (quill) {
        quill.blur();
      }
      this.modalActive = false;
      this.$emit('close');
    },
    onModalOpened() {
      this.modalActive = true;
      this.focusEditor();
    },
    focusEditor(retryCount = 0) {
      if (!this.modalActive) {
        return;
      }
      this.$nextTick(() => {
        const quill = this.$refs.quill && this.$refs.quill.quill;
        if (!quill) {
          if (retryCount < 5) {
            setTimeout(() => this.focusEditor(retryCount + 1), 50);
          }
          return;
        }
        quill.focus();
        const length = quill.getLength();
        quill.setSelection(length, 0);
      });
    }
  }
};
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 200;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80% !important;
  height: 100% !important;
  margin: 65px auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
  text-align: center;
}

.modal-container .btn {
  margin: 0 auto;
}

.modal-header {
  margin-top: 0;
  color: #2c3e50;
  font-size: 30px;
  border-bottom: 0px !important;
}

.modal-body {
  margin: 20px 0;
  white-space: pre-line;
  height: 100%;
}

.modal-default-button {
  margin: 0 auto;
}

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.btn-danger {
  float: left;
}

#trumbowyg_wrapper {
  text-align: left;
  margin-top: 0px !important;
  margin-bottom: 0px !important;
  padding-top: 0px !important;
}
div >>> .quill-editor,
div >>> .ql-editor {
  height: 40vh;
  overflow-y: scroll;
}
/* Restore list styles inside Quill editor */
div >>> .ql-editor ul {
  list-style-type: disc;
  padding-left: 1.5em;
}

div >>> .ql-editor ol {
  list-style-type: decimal !important;
  padding-left: 1.5em;
}

div >>> .ql-editor li {
  display: list-item !important;
}

/* in noHTML mode, gray out and disable toolbar that adds formatting/HTML */
.disable-toolbar >>> .ql-toolbar {
  opacity: 0.4;
  pointer-events: none;
}

</style>